import { useEffect } from 'react'

/**
 * 배경 문서의 스크롤을 잠근다.
 *
 * 겹쳐 잠글 수 있어야 한다 — 로딩 화면이 잠근 채 그 위에 모달이 열려도, 모달이
 * 닫히는 순간 로딩 화면의 잠금까지 같이 풀려버리면 안 된다. 그래서 모듈 수준에서
 * 잠금 수를 세고, 마지막 하나가 풀릴 때만 원래 값으로 되돌린다.
 */
let locks = 0
let previousOverflow = ''

export function useBodyScrollLock(active = true): void {
  useEffect(() => {
    if (!active) return
    if (locks === 0) {
      previousOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
    }
    locks += 1
    return () => {
      locks -= 1
      if (locks === 0) document.body.style.overflow = previousOverflow
    }
  }, [active])
}
